import React from "react";
import { Gauge } from "@ant-design/plots";
import { behaviorMatchColors } from "../../config/Colors.config";

function GaugeChart({
    percent = 100,
    style = {},
    titleColor
}) {
    const config = {
        percent: percent / 100,
        range: {
            ticks: [0, 0.1, 0.2, 0.4, 1],
            color: [...behaviorMatchColors].reverse(),
            width: 20
        },
        startAngle: Math.PI,
        endAngle: 2 * Math.PI,
        indicator: {
            pointer: {
                style: {
                    stroke: "transparent"
                }
            },
            pin: {
                style: {
                    fill: "transparent",
                    stroke: "transparent"
                }
            }
        },
        axis: {
            label: {
                formatter(v) {
                    return `${Number(v) * 100}%`;
                }
            },
            verticalFactor: -1.5,
            subTickLine: {
                count: 0
            },
            tickInterval: 0.1
        },
        padding: 15,
        statistic: {
            title: {
                offsetY: -20,
                style: {
                    fontSize: "25px",
                    fontWeight: "600",
                    color: titleColor || "#4B535E"
                },
                formatter: () => `${parseInt(percent, 10)}%`
            }
        }
    };
    return (
        <div className="guage-chart" style={{ height: "100%", width: "100%", ...style }}>
            <Gauge {...config} />
        </div>
    );
}

export default GaugeChart;
